import React from 'react';

// Hover, focus and motion rules the inline styles cannot express; every rule is scoped to .pu-scope so nothing leaks into the host.
// Hover rules carry !important because inline styles win otherwise.
const CSS = `
.pu-scope { font-family: Inter, system-ui, -apple-system, "Segoe UI", sans-serif; color: #222525; font-size: 14px; line-height: 20px; -webkit-font-smoothing: antialiased; }
.pu-scope *, .pu-scope *::before, .pu-scope *::after { box-sizing: border-box; }
.pu-scope h1, .pu-scope h2, .pu-scope h3, .pu-scope p, .pu-scope dl, .pu-scope dd, .pu-scope figure { margin: 0; }
.pu-scope ul, .pu-scope ol { margin: 0; padding: 0; list-style: none; }
.pu-scope button, .pu-scope input, .pu-scope select, .pu-scope textarea { font-family: inherit; }
.pu-scope th { font-weight: 600; }
.pu-scope :focus-visible { outline: 2px solid #0F7679; outline-offset: 2px; }
/* Page sections keep their height and the page scrolls; a card with overflow hidden would shrink to fit otherwise. */
.pu-frame > * { flex-shrink: 0; }
.pu-scope :disabled { opacity: 0.45; cursor: not-allowed; }
.pu-sr { position: absolute; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }
.pu-scope .pu-btn-primary:hover:not(:disabled) { background: #0D5759 !important; border-color: #0D5759 !important; }
.pu-scope .pu-btn-secondary:hover:not(:disabled) { background: #F3FAFA !important; }
.pu-scope .pu-btn-text:hover:not(:disabled) { color: #0D5759 !important; text-decoration: underline; }
.pu-scope .pu-btn-icon:hover:not(:disabled) { background: #EBF0F0 !important; color: #222525 !important; }
.pu-scope .pu-btn-remove:hover:not(:disabled) { background: #EBF0F0 !important; color: #BA0E13 !important; }
.pu-scope .pu-btn-danger:hover:not(:disabled) { background: #FDF5F5 !important; }
.pu-scope .pu-btn-danger-solid:hover:not(:disabled) { background: #9A0B10 !important; border-color: #9A0B10 !important; }
.pu-scope .pu-link:hover { text-decoration: underline; }
.pu-scope .pu-seg[aria-pressed="false"]:hover { color: #05292A !important; }
.pu-scope .pu-chip[aria-pressed="false"]:hover { background: #F3FAFA !important; }
.pu-scope .pu-filter:hover { border-color: #C9D7D8 !important; }
.pu-scope .pu-strip-btn[aria-pressed="false"]:hover { background: #F9FBFB !important; }
.pu-scope .pu-menu-item:hover { background: #F3FAFA !important; }
.pu-scope .pu-menu-item:focus-visible, .pu-scope .pu-inset:focus-visible { outline-offset: -2px; }
.pu-scope .pu-row:hover > td { background: #F9FBFB; }
.pu-scope .pu-row:focus-within > td { background: #F3FAFA; }
.pu-scope .pu-click-row { cursor: pointer; }
.pu-scope .pu-input::placeholder { color: #6A7878; opacity: 1; }
.pu-scope .pu-input[aria-invalid="true"]::placeholder, .pu-scope .pu-input:disabled::placeholder { color: #4A5353; }
.pu-scope .pu-input:focus-visible { outline: 2px solid #0F7679; outline-offset: -1px; border-color: #0F7679 !important; }
.pu-scope .pu-input[aria-invalid="true"]:focus-visible { outline-color: #BA0E13; border-color: #BA0E13 !important; }
.pu-scope .pu-input:disabled { opacity: 1; background: #F9FBFB !important; color: #4A5353 !important; }
.pu-scope .pu-check { accent-color: #0F7679; }
@supports selector(:has(a)) {
  .pu-scope .pu-filter:has(select:focus-visible) { outline: 2px solid #0F7679; outline-offset: 2px; }
  .pu-scope .pu-filter select:focus-visible { outline: none; }
}
.pu-dialog { animation: pu-rise 200ms cubic-bezier(.2,.8,.2,1); }
.pu-sheet { animation: pu-slide 220ms cubic-bezier(.2,.8,.2,1); }
@keyframes pu-rise { from { transform: translateY(8px) scale(0.98); } to { transform: none; } }
@keyframes pu-slide { from { transform: translateY(24px); } to { transform: none; } }
@keyframes pu-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.55; } }
.pu-skeleton { animation: pu-pulse 1.4s ease-in-out infinite; }
@media (max-width: 1359px) {
  .pu-scope .pu-split-wide { grid-template-columns: minmax(0, 1fr) !important; }
}
@media (prefers-reduced-motion: reduce) {
  .pu-scope *, .pu-dialog, .pu-sheet, .pu-skeleton { animation: none !important; transition: none !important; scroll-behavior: auto !important; }
}
@media print {
  .pu-no-print { display: none !important; }
}
`;

/** Render once per purchasing page, inside its .pu-scope root. */
export const PurchasingStyles: React.FC = () => <style>{CSS}</style>;
